<script>
  import {
    selectedProcedures,
    procedureList,
    commonData,
    selectedPart,
    selectedArea,
  } from '../../../../../../../../store/common';
  import isEmpty from '../../../../../../../../core/utils/isEmpty';

  const onSelectProcedure = id => {
    if (isSelected(id)) {
      selectedProcedures.update(prev => prev.filter(item => item.id !== id));
    } else {
      selectedProcedures.update(prev => [
        ...prev,
        procedures().filter(item => item.id === id)[0],
      ]);
    }
  };

  $: isSelected = id => {
    let boolean = false;

    $selectedProcedures.forEach(item => {
      if (item.id === id) {
        boolean = true;
      }
    });

    return boolean;
  };

  const getAllProcedures = () => {
    let arr = [];

    $commonData.forEach(
      areaItem =>
        $selectedArea.body_area === areaItem.body_area &&
        areaItem.body_parts.map(itemPart =>
          itemPart.procedures.map(procedureItem => arr.push(procedureItem)),
        ),
    );

    return arr;
  };

  $: procedures = () => {
    if (!isEmpty($selectedPart)) {
      return $procedureList;
    }

    return getAllProcedures();
  };
</script>

<div class="uk-position-relative">
  <ul class="uk-list uk-list-striped uk-text-small uk-overflow-auto">
    {#each procedures() as item}
      <li
        class={`uk-flex uk-flex-between uk-flex-middle ${
          isSelected(item.id) ? 'is-selected' : ''
        }`}
      >
        <span class="uk-padding-small uk-text-secondary text-ellipsis">
          <strong>
            {item.name}
            {#if isEmpty($selectedPart)}
              / {item.body_part_name} / {item.body_area_name}
            {/if}
          </strong>
          <br />
          <span class="text-xsmall">
            {@html item.description}
          </span>
        </span>

        <button
          class="uk-icon-button background-transparent"
          type="button"
          data-uk-icon={isSelected(item.id) ? 'minus-circle' : 'plus-circle'}
          on:click={() => onSelectProcedure(item.id)}
        />
      </li>
    {/each}
  </ul>
</div>
